import { createApiCall } from 'lib/base';

const FETCH_STAFF_USER_ASSIGNMENT_DETAIL =
  'FETCH_STAFF_USER_ASSIGNMENT_DETAIL';

const apiCall = createApiCall(
  FETCH_STAFF_USER_ASSIGNMENT_DETAIL,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/wealth/user-assignments/${id}`,
    method: 'GET',
  })
);

export default apiCall;
